import React from "react";
import { FolderOpen } from "lucide-react";
import { useSelector } from "react-redux";

const FolderSearch = ({ folders }) => {
  const { userDetail } = useSelector((state) => state.users);

  const inherit = userDetail.preferences.inherit_from_parent_folder;
  const enableColor = userDetail.preferences.enable_folder_color;

  const folderItem = (item, parentColor = null) => {
    const folderColor =
      inherit === "true" ? parentColor || item.color_code : item.color_code;

    return (
      <div key={item.id}>
        <div className="flex items-center flex-wrap gap-2.5 my-2">
          <FolderOpen
            color={enableColor === "false" ? "black" : folderColor}
            size={20}
            strokeWidth={1.5}
          />
          <span className="text-mono text-sm font-medium">{item.name}</span>
        </div>
        {item.subfolders?.length > 0 &&
          item.subfolders.map((sub) => (
            <div key={sub?.id} className="pl-6">
              {folderItem(sub, folderColor)}
            </div>
          ))}
      </div>
    );
  };

  return (
    <>
      {folders?.folders?.map((item) => (
        <div
          key={item?.id}
          className="flex flex-col group border border-border rounded-xl gap-2 px-3.5 py-2.5"
        >
          {folderItem(item)}
        </div>
      ))}
    </>
  );
};

export default FolderSearch;
